<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Invoice Expenses Payment Details</b-navbar-brand>
        </b-navbar>
        <b-card>
          <b-row>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="25" md-flex-small="100">
                <date-range-picker :opens="openRight" :always-show-calendars="showCal" v-model="dateRange"
                  :startDate="startDate" :endDate="endDate" :locale-data="locale">
                </date-range-picker>
              </md-layout>
            </b-col>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="25" md-flex-small="100">
                <model-list-select class="" :list="getVendorData" id="vendorNamenew" v-model="vendorIdFilter"
                  option-value="refuelStationId" option-text="vendorName"
                  placeholder="Select Vendor Name"></model-list-select>
              </md-layout>
            </b-col>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="25" md-flex-small="100">
                <b-form-input :formatter="capitalizeAll" v-model="InvoiceNoFilter"
                  placeholder=" Invoice Number"></b-form-input>
              </md-layout>
            </b-col>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="25" md-flex-small="100">
                <b-form-input :formatter="capitalizeAll" v-model="assignmentFilter"
                  placeholder=" Assignment No."></b-form-input>
              </md-layout>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="25" md-flex-small="100">
                <model-list-select :list="branchList" v-model="branchfilter" option-value="pickupId"
                  option-text="pickupLocation" placeholder=" Branch"></model-list-select>
              </md-layout>
            </b-col>
            <b-col md="3" class="mb-1">
              <md-layout md-flex="25" md-flex-small="100">
                <model-list-select :list="invoiceStatusList" v-model="statusFilter" option-value="inv" option-text="int"
                  placeholder="Select Status"></model-list-select>
              </md-layout>
            </b-col>
            <b-col md="6" class="mb-1">
              <b-button size="sm" class="ml-auto" @click="filterSearch" variant="outline-primary">Search</b-button>
              <b-button size="sm" class="ml-2" @click="clearFilter" variant="outline-info">clear</b-button>
              <!-- <b-button
                size="sm"
                class="ml-2"
                @click="getReports('Expenses_SCREEN')"
                variant="outline-info"
                >Export All Execution
              </b-button> -->
              <b-button :disabled="ExcelBtnName != 'Export All Execution' ? true : false" class="ml-2"
                @click="getReports('Expenses_SCREEN', 'Export All Execution')" size="sm" variant="outline-info">{{
                ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export All Execution'" small
                  label="Small Spinner"></b-spinner></b-button>
            </b-col>
          </b-row>
          <div class="gutr"></div>
        </b-card>

        <div>
          <span class="text-muted pull-left mt-2 ml-3">
            <input type="checkbox" @click="SelectAll(ExpenseData)" v-model="isCheckAll" />
            <label>Select / Deselect All</label>

            <b-button v-if="Exp_ids.length > 0" size="sm" class="mt-2 mb-2" @click="openPayMultiPaymentModal"
              variant="outline-primary">Mark As Paid</b-button>
          </span>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
        </div>

        <!-- Modal Section Start -->
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="PayMultiPayment-modal" hide-footer title="">
          <div class="d-block text-center">
            <h3>Multi Expense Payment Details</h3>
          </div>

          <b-row class="mt-2">
            <b-col cols="3"><label>Payment Amount</label>
              <b-form-input :formatter="capitalizeAll" name="PaymentAmount" id="PaymentAmount" v-model="invPaidAmount"
                type="number"></b-form-input>
              <span class="error" v-if="invPaidAmount_err ? true : false">{{
                invPaidAmount_err
                }}</span>
            </b-col>
            <b-col cols="3"><label>Payment Ref</label>
              <b-form-input :formatter="capitalizeAll" name="PaymentRef" id="PaymentRef"
                v-model="invPayRef"></b-form-input>
              <span class="error" v-if="invPayRef_err ? true : false">{{
                invPayRef_err
                }}</span>
            </b-col>
            <b-col cols="3"><label>Payment Date</label>
              <date-picker :format="selectDateFormat" lang="en" name="PaymentDate" id="PaymentDate" v-model="invPayDate"
                :minute-step="1" @input="onChooseInvoiceDate($event)">
              </date-picker>
              <span class="error" v-if="invPayDate_err ? true : false">{{
                invPayDate_err
                }}</span>
            </b-col>
            <b-col cols="3">
              <label for="Remarks">Remarks</label>
              <b-form-textarea :formatter="capitalizeAll" v-model="invPayremarks"></b-form-textarea></b-col>
          </b-row>
          <span class="center">
            <b-button class="mt-3" variant="success" @click="SavePayMultiPayment" block>Pay</b-button>
            <b-button class="mt-3" variant="danger" block @click="hidePayMultiPaymentModal">Close</b-button>
          </span>
        </b-modal>
        <!-- Modal Section End -->

        <!-- Main table element -->

        <div class="table-responsive tableMain mt-2">
          <b-table show-empty stacked="md" :items="ExpenseData" :fields="fields" :per-page="perPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
            <!-- @click='SelectAll(row0.item.exp_id)' -->
            <template slot="serialno" slot-scope="row0">
              <input type="checkbox" v-bind:value="row0.item.exp_id" v-model="Exp_ids" @change="updateSelectAll()" />
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="assign_Series" slot-scope="row1">
              <span>
                <b>
                  {{
                  row1.item.assign_Series ? row1.item.assign_Series : "NA"
                  }}</b>
              </span>
            </template>
            <template slot="VendorName" slot-scope="row2">
              <span>
                {{ row2.item.vendorName ? row2.item.vendorName : "NA" }}
              </span>
            </template>
            <template slot="BranchName" slot-scope="row3">
              <span>
                {{ row3.item.mainLocation ? row3.item.mainLocation : "NA" }}
              </span>
            </template>

            <template slot="exp_type" slot-scope="row4">
              <span>
                {{ row4.item.exp_type ? row4.item.exp_type : "NA" }}
              </span>
            </template>
            <template slot="exp_amount" slot-scope="row5">
              <span>
                {{ row5.item.exp_amount ? row5.item.exp_amount : "NA" }}
              </span>
            </template>
            <template slot="invoice_no" slot-scope="row6">
              <span>
                {{ row6.item.invoice_no ? row6.item.invoice_no : "NA" }}
              </span>
            </template>
            <template slot="invDate" slot-scope="row61">
              <span>
                {{ row61.item.invDate ? row61.item.invDate : "NA" }}
              </span>
            </template>
            <template slot="payRefNumber" slot-scope="row7">
              <span>
                {{ row7.item.payRefNumber ? row7.item.payRefNumber : "NA" }}
              </span>
            </template>
            <template slot="remark" slot-scope="row8">
              <span>
                {{ row8.item.exp_remarks ? row8.item.exp_remarks : "NA" }}
              </span>
            </template>

            <template slot="InvPayStatus" slot-scope="row9">
              <b-badge variant="danger" v-if="
                  row9.item.InvPayStatus != null &&
                  row9.item.InvPayStatus == '0'
                ">Pending</b-badge>
              <!-- <b-badge variant="warning" v-else-if="
                  row9.item.InvPayStatus != null && row9.item.InvPayStatus == '1'
                ">Partial</b-badge> -->
              <b-badge variant="success" v-else-if="
                  row9.item.InvPayStatus != null &&
                  row9.item.InvPayStatus == '2'
                ">Completed</b-badge>
            </template>
            <template slot="ExpenseCreated" slot-scope="row10">
              <span>
                {{ row10.item.loginTime ? row10.item.loginTime : "NA" }}
              </span>
            </template>
            <template slot="exp_id" slot-scope="row11">
              <b-button v-if="accounts == true" @click="
                  goExpensePay(
                    (Paytype = 'Single'),
                    row11.item.exp_id,
                    row11.item.allModuleId,
                    row11.item.assign_Series
                  )
                " size="sm" variant="outline-danger">Single Pay</b-button><br />
              <b-button v-if="accounts == true" @click="
                  goExpensePay(
                    (Paytype = 'All'),
                    row11.item.exp_id,
                    row11.item.allModuleId,
                    row11.item.assign_Series
                  )
                " size="sm" variant="outline-danger">All Pay</b-button><br />
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination limit="25" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/Expense/expPaymentDash");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewImport("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Export All Execution",
      validateINV: true,
      invPaidAmount: "",
      invPayRef: "",
      invPayremarks: "",
      invPayDate: "",
      selectDateFormat,

      invPayDate_err: "",
      invPaidAmount_err: "",
      invPayRef_err: "",

      isCheckAll: false,
      Exp_ids: [],
      selectedExp_ids: "",
      accounts: globalPermissionStatus("Accounts"),
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      closingReason: "",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "serialno",
          mainkey: "serialno",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "assign_Series",
          mainkey: "assign_Series",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "VendorName",
          mainkey: "VendorName",
          label: "Vendor Name",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "BranchName",
          mainkey: "BranchName",
          label: "Branch Name",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "exp_type",
          mainkey: "exp_type",
          label: "Expense Type",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "exp_amount",
          mainkey: "exp_amount",
          label: "Expense Amount",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "invoice_no",
          mainkey: "invoice_no",
          label: "Invoice No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "invDate",
          mainkey: "invDate",
          label: "Invoice Date",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "remark",
          mainkey: "remark",
          label: "Remark",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "payRefNumber",
          mainkey: "payRefNumber",
          label: "Payment Ref.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "InvPayStatus",
          mainkey: "InvPayStatus",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "ExpenseCreated",
          mainkey: "ExpenseCreated",
          label: "Created DT.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "exp_id",
          mainkey: "exp_id",
          label: "Actions",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      mailallModuleId: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      vendorIdFilter: "",
      assignmentFilter: "",
      InvoiceNoFilter: "",
      selectedAllModuleId: "",
      statusFilter: "0",
      branchfilter: "",
      getVendorData: [],
      ExpenseData: [],
      reload: true,
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        // {
        //   inv: "1",
        //   int: "Partial",
        // },
        {
          inv: "2",
          int: "Completed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sortOptions1() {
      // Create an options list from our fields
      return this.fields1
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    vendorIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.vendorIdFilter ||
          this.InvoiceNoFilter ||
          this.branchfilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "3";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.vendorIdFilter ||
          this.InvoiceNoFilter ||
          this.branchfilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "3";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.vendorIdFilter ||
          this.InvoiceNoFilter ||
          this.branchfilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "3";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    InvoiceNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.vendorIdFilter ||
          this.InvoiceNoFilter ||
          this.branchfilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "3";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
  },
  methods: {
    // Exp_ids: [],
    // selectedExp_ids: "",

    onChooseInvoiceDate(event, item) {
      this.$forceUpdate();
    },
    openPayMultiPaymentModal(id) {
      this.$refs["PayMultiPayment-modal"].show();
    },

    hidePayMultiPaymentModal() {
      this.$refs["PayMultiPayment-modal"].hide();
    },
    validateINVDetail() {
      let validate_new = true;

      if (this.invPayRef == "") {
        this.invPayRef_err = "Payment Ref Field is Required";
        validate_new = false;
      } else {
        this.invPayRef_err = "";
        validate_new = true;
      }
      if (this.invPayDate == "") {
        this.invPayDate_err = "Payment Date Field is Required";
        validate_new = false;
      } else {
        this.invPayDate_err = "";
        validate_new = true;
      }

      if (this.invPaidAmount == "") {
        this.invPaidAmount_err = "Paid Amount Field is Required";
        validate_new = false;
      } else {
        this.invPaidAmount_err = "";
        validate_new = true;
      }
      if (validate_new == false) {
        this.validateINV = false;
      } else {
        this.validateINV = true;
      }
    },
    SavePayMultiPayment() {
      // alert("Hello");
      this.validateINVDetail();
      // console.log(this.invPayDate_err);
      if (this.validateINV == false) {
        return false;
      }
      let my_Data = {
        invPayDate: this.invPayDate,
        invPayRef: this.invPayRef,
        invPaidAmount: this.invPaidAmount,
        invPayremarks: this.invPayremarks,
        Exp_ids_arr: this.Exp_ids,
      };
      // this.PayMultiPayment;
      if (this.invPaidAmount != "") {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Expenses/multiPaymentExpense.php`,
          data: JSON.stringify(my_Data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              console.log(data);
              if (data.Message == "Updated Success Fully") {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              this.hidePayMultiPaymentModal();
            }
          })
          .catch((error) => {});
      }
    },
    SelectAll: function () {
      console.log("this.ExpenseData=>", this.ExpenseData);
      this.isCheckAll = !this.isCheckAll;
      this.Exp_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.ExpenseData) {
          this.Exp_ids.push(this.ExpenseData[key].exp_id);
        }
        console.log("this.Exp_ids=>", this.Exp_ids);
      }
    },
    updateSelectAll: function () {
      if (this.Exp_ids.length == this.ExpenseData.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      console.log("this.Exp_ids=>", this.Exp_ids);
    },

    // SelectAll() {
    //   console.log("Hello");
    // },
    vendorFilter(list, query) {
      return this.getVendorData.filter((x) => {
        return x.vendorName.toLowerCase().includes(query.toLowerCase());
      });
    },
    getReports(id, btnName) {
      //this.isLoading = true;
      let excelIdGivin = "";
      if (id == "Expenses_SCREEN") {
        excelIdGivin = "Expenses_SCREEN";
      } else if (id == "Expenses_SCREEN_ALL") {
        excelIdGivin = "Expenses_SCREEN_ALL";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        vendorIdFilter: this.vendorIdFilter,
        assignmentFilter: this.assignmentFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/getAlllExcelExpensePayment.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ExcelBtnName = btnName;
            if (data.excelName != undefined) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` +
                data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    previousSalesView() {
      window.history.go(-1);
    },
    closeModalConfirm() {
      (this.incompleteJobBill = ""), this.$refs["modal-close-conf"].hide();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewImport("0", CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewImport("0", "1", "1");
    },
    clearFilter() {
      this.dateSearch.fromDate = "";
      this.dateSearch.toDate = "";
      this.dateRange.startDate = "";
      this.dateRange.endDate = "";
      this.vendorIdFilter = "";
      this.statusFilter = "";
      this.branchfilter = "";
      this.assignmentFilter = "";
      this.assignmentNo = "";
      this.InvoiceNoFilter = "";
      this.statusFilter = "0";
      (this.dateRange = {
        startDate: "",
        endDate: "",
      }),
        (this.filter = "");
      this.viewImport("0", "0", "1", "1");
    },

    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewImport("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },

    closeDialogConfirm() {
      this.$refs["confirmModal"].hide();
    },
    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goExpensePay(Paytype, exp_id, allModuleId, assign_Series) {
      // alert(Paytype);
      // alert(exp_id);
      // alert(allModuleId);
      // alert(assign_Series);
      if (exp_id != "" && allModuleId != "" && assign_Series != "") {
        this.$sessionsStorage.set("allModuleIdMain",'');
        this.$sessionsStorage.set("JOBSERIES",'');
        this.$sessionsStorage.set("JOBSERIES", assign_Series);
        this.$sessionsStorage.set("allModuleIdMain", allModuleId);
        if (Paytype == "Single") {
          this.$sessionsStorage.set("exp_id", "");
          this.$sessionsStorage.set("exp_id", exp_id);
        } else if (Paytype == "All") {
          this.$sessionsStorage.set("exp_id", "");
          this.$sessionsStorage.set("exp_id", "");
        }

        this.$router.push({
          path: "/allModule/Expenses",
        });
      } else {
        this.$router.push({
          path: "/Expense/expPaymentDash",
        });
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },
    viewImport(CURRENT, SEARCH, pageNumber) {
      // alert(CURRENT);

      // this.isLoading = true;
      let payload = {
        view: "view",
        searchVal: this.filter,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,

        assignmentFilter: this.assignmentFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        vendorIdFilter: this.vendorIdFilter,
      };
      console.log(payload);
      // return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/getExpensePaymentListMulti.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("MYDATAARR=>", data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }

            if (data.mainExpensesData.length > 0) {
              this.ExpenseData = data.mainExpensesData;
            } else {
              this.ExpenseData = [];
            }

            if (this.reload == true) {
              if (data.Vendordetail.length > 0) {
                this.getVendorData = data.Vendordetail;
              } else {
                this.getVendorData = [];
              }
              if (data.BranchDetails.length > 0) {
                this.branchList = data.BranchDetails;
              } else {
                this.branchList = [];
              }
            }

            // this.JqueryFun();
            this.isLoading = false;
            //
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}

</style>



// WEBPACK FOOTER //
// ExpensePaymentDashboard.vue?76be956b